import React  from 'react';
import {
    Button, FormControl,
    Grid, IconButton,
    InputAdornment,
    InputLabel,
    Link,
    OutlinedInput,
    Paper,
    TextField,
    Typography
} from "@material-ui/core";
import logo from '../../assets/images/logo.png'
import '../login/Login.css'
import {NavLink, useLocation, useNavigate} from "react-router-dom";
import {RouteInfo} from "../../route/RouteHelper";
import {useAuthState} from "../../context/AuthContext";
import {useEffect, useState} from "react";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import {convertToMobileNumber} from "../../utils/numberConvertor";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {LoginService} from "../login/LoginService";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";


const ConfirmPhoneNumber = () => {

    const snackbarState = useSnackbarDispatcher()
    const token = useAuthState().token
    const loading = useLoadingDispatcher()

    const service = new LoginService()


    const location = useLocation()
    const navigation = useNavigate()

    const [phoneNumber, setPhoneNumber] = useState("");
    const [nationalCode, setNationalCode] = useState("");
    const [confirmCode, setConfirmCode] = useState("");

    useEffect(() => {
        if (location.state) {
            setPhoneNumber(location.state.phoneNumber)
            setNationalCode(location.state.nationalCode)
        } else {
            window.history.pushState({}, null, RouteInfo.Login.globalUrl);
        }
    }, [location.state]);


    useEffect(() => {
        if (typeof token !== "undefined" && token !== null) {
            // navigate(RouteInfo.Root.url)
        }
    }, [token])

    const [passwordValue, setPasswordValue] = useState({
        amount: '',
        password: '',
        weight: '',
        weightRange: '',
        showPassword: false,
    });


    const handleChange = (prop) => (event) => {
        setPasswordValue({...passwordValue, [prop]: event.target.value});
    };

    const handleClickShowPassword = () => {
        setPasswordValue({...passwordValue, showPassword: !passwordValue.showPassword});
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    function handleResetPassword() {
        if (checkFields()) {
            loading(setLoadingStateDispatch(true))
            service.resetPassword(
                nationalCode,
                phoneNumber,
                confirmCode,
                passwordValue
            ).then(response => {
                snackbarState(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "رمز عبور با موفقیت بروزرسانی شد."))
                navigation(RouteInfo.Login.globalUrl)
                loading(setLoadingStateDispatch(false))
            }).catch(reason => {
                ServerErrorHandler(reason, "خطا در تغییر رمز عبور!",snackbarState,loading)
            })
        }
    }

    function checkFields() {
        let message = ""
        let state = true
        if (passwordValue.password.length < 8) {
            state = false
            message = "رمز عبور باید بیش از 8 کاراکتر باشد!"
        } else if (confirmCode.length === 0) {
            state = false
            message = "لطفا کد تایید را وارد نمایید!"
        }

        if (message.length > 0)
            snackbarState(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, message))
        return state
    }

    return (
        <Grid xs={12} id="login-container">
            <Grid style={{width: "100%"}} xs={11} sm={9} md={6} lg={5} xl={3}>
                <Paper id='login-paper' elevation='2'>
                    <img src={logo} alt=""/>
                    <Typography
                        variant='h6'>
                        سامانه مدیریت صندوق های مردمی
                    </Typography>
                    <Typography
                        variant='subtitle2'
                        style={{marginTop: '8px', marginBottom: '1rem'}}
                    >
                        لطفا کد ارسال شده را وارد نمایید!
                    </Typography>
                    <TextField
                        variant='outlined'
                        label='شماره همراه'
                        disabled={true}
                        value={convertToMobileNumber(phoneNumber)}
                        dir={"ltr"}
                    />
                    <TextField
                        variant='outlined'
                        label='کد ملی'
                        disabled={true}
                        value={nationalCode}
                        dir={"ltr"}
                    />
                    <FormControl variant="outlined" className='w-100'>
                        <InputLabel htmlFor="outlined-adornment-password">رمز عبور جدید</InputLabel>
                        <OutlinedInput
                            label="رمز عبور جدید"
                            id="outlined-adornment-password"
                            type={passwordValue.showPassword ? 'text' : 'password'}
                            value={passwordValue.password}
                            onChange={handleChange('password')}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {passwordValue.showPassword ? <Visibility/> : <VisibilityOff/>}
                                    </IconButton>
                                </InputAdornment>
                            }
                            labelWidth={70}
                        />
                    </FormControl>
                    <TextField
                        variant='outlined'
                        label='کد تایید'
                        value={confirmCode}
                        onChange={e => setConfirmCode(e.target.value)}
                        dir={"ltr"}
                    />

                    <Button className="btn-confirm"
                            onClick={handleResetPassword}
                    >
                        بررسی کد تایید
                    </Button>
                    <NavLink
                        className="fs-0"
                        to={RouteInfo.ForgetPassword.globalUrl}
                    >
                        ویرایش اطلاعات ورود
                    </NavLink>

                    <Typography
                        variant='caption'
                        id='copyrightContainer'
                    >
                        <Link
                            href="https://raiko.app"
                            target='_blank'
                            color='inherit'
                            style={{textDecoration: "none"}}
                        >
                            {/*raiko.app@2021 All rights reserved*/}
                            ساخته شده با ❤️ توسط رایکو
                        </Link>
                    </Typography>
                </Paper>

            </Grid>

        </Grid>
    )
}
export default ConfirmPhoneNumber;